var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"copyBox",attrs:{"value":_vm.value,"readonly":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-btn',{attrs:{"fab":"","icon":"","small":""},on:{"click":_vm.onCopy}},[_c('v-icon',[_vm._v(" mdi-content-copy ")])],1)]},proxy:true}])},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }